/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseWorkPackageDto } from '../../models/base-work-package-dto';

export interface GetWorkPackage$Params {
  id: string;
}

export function getWorkPackage(http: HttpClient, rootUrl: string, params: GetWorkPackage$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseWorkPackageDto>> {
  const rb = new RequestBuilder(rootUrl, getWorkPackage.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseWorkPackageDto>;
    })
  );
}

getWorkPackage.PATH = '/v0/workPackages/{id}';
